import { IonItem, IonLabel, IonButton, IonContent, IonPage, IonCol, IonGrid, IonRow } from "@ionic/react";
import { useEffect, useState } from "react";
import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { bewohnerlisteErstellen } from "./bewohnerlisteErstellen";
import { mk_ion_header } from "../functions/mk_ion_header";
import { get_bewohner_station } from "../functions/get_bewohner_station";
import { formatWoche } from "../functions/formatWoche";

export default function Bewohner( { modus = 'soll' }) {
  const { appBewohnerIdChange, appBewohnerIndexChange, appBewohnerSollIdChange, appBewohnerSollBezeichnungChange, appSollReloadAuswahlChange, appSollReloadBestellstatus, appSollReloadBestellstatusChange, appServer, appStation, appStationBezeichnung, appToken } = useContext(DataContext);
  const [bestellstatus, setBestellstatus]:any = useState();
  const [bewohner, setBewohner]:any = useState();
  const [bewohnerliste, setBewohnerliste]:any = useState(
    <IonItem>
      <IonLabel>Lade Bewohner</IonLabel>
    </IonItem>
  );

  let do_bewohner_choice_settings = (entry: any, index?: number ) => {} ;
  let my_link_root = '';
  if( modus === 'ist' ) {
    my_link_root = `/tag/2/${new Date().toISOString().slice(0, 10)}`;
    do_bewohner_choice_settings = (entry: any, index?: number) => {
      appBewohnerIdChange(entry.betriebe_bewohner_id);
      appBewohnerIndexChange(index);
    };
  }
  if( modus === 'soll' ) {
    my_link_root = `/speisekarte/${appStation}/${appStationBezeichnung}`;
    do_bewohner_choice_settings = (entry: any) => {
      appBewohnerSollIdChange(entry.betriebe_bewohner_id);
      appBewohnerSollBezeichnungChange(entry.betriebe_bewohner_nachname + "_" + entry.betriebe_bewohner_vorname);
      appSollReloadAuswahlChange(true);
    };
  }

  const getBestellStatus = () => {
    if( ! bewohner ) return ;
    setBewohnerliste( 'Lade Daten ...' ) ;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    myHeaders.append("Authorization", "Bearer " + appToken);

    let my_data: any = { mahlzeiten: [] , zeitraeume: [] , user_ids: [] } ;
    my_data.mahlzeiten.push( '2' ) ;
    for( let i = 0; i < 4; i++ ) {
      my_data.zeitraeume.push( formatWoche( i, 'ISO-Date' ) ) ;
    }
    my_data.user_ids = bewohner.map( ( entry:any ) => entry.betriebe_bewohner_id) ;

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify( my_data )
    };
    fetch(appServer + "/funktionen/api2/senioren/bestellstatus.php", requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        setBestellstatus( result )
      });
  };

  const mk_header_second_line =
    () => {
      let my_back_button = <IonButton routerLink={ '/stationen' }>zurück</IonButton> ;
      if( modus !== 'soll' ) return my_back_button ;
      let my_date_cols = [] ;
      for( let i = 0; i < 4; i++ ) {
        my_date_cols.push( <IonCol key={ "date_col_" + i } style={{textAlign:'center'}}>{formatWoche( i, '' )}</IonCol> ) ;
      }
      let my_line =
        <IonGrid key="data_grid">
          <IonRow>
            <IonCol key="col_bewohner" size="3">
              { my_back_button }
            </IonCol>
            { my_date_cols }
          </IonRow>
        </IonGrid>
      ;
      return my_line ;
    }
  ;

  useEffect(() => {
    get_bewohner_station( appStation, (value: any) => setBewohner( value ) );
  }, [ appStation ]);

  useEffect(() => {
    if (!appSollReloadBestellstatus) return;
    getBestellStatus() ;
  }, [ appSollReloadBestellstatus ]);

  useEffect(() => {
    if (!bewohner) return;
    if( modus === 'soll' ) getBestellStatus() ;
    if( modus === 'ist' ) {
      let my_bewohnerliste = bewohnerlisteErstellen( modus, bewohner, my_link_root, do_bewohner_choice_settings);
      setBewohnerliste(my_bewohnerliste);  
    }
  }, [ bewohner ]);

  useEffect(() => {
    if (!bestellstatus) return;
    let my_bewohnerliste = bewohnerlisteErstellen( modus, bewohner, my_link_root, do_bewohner_choice_settings, bestellstatus );
    setBewohnerliste(my_bewohnerliste);
    appSollReloadBestellstatusChange(false);
  }, [ bestellstatus ]);

  return (
    <IonPage>
      { mk_ion_header( appStationBezeichnung ) }
      <IonContent key="bewohner_liste" fullscreen>
        { mk_ion_header( appStationBezeichnung , 'large', mk_header_second_line() ) }
        {bewohnerliste}
      </IonContent>
    </IonPage>
  );
}
